export default __webpack_public_path__ + "static/media/team3.23408958.png";